import { useLang } from "../../lib/lang";
import { SectionHead, Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-8">
      <div className="lg:col-span-5"><SectionHead eyebrow={t.faqEyebrow} title={t.faqTitle} testid="faq-title" /></div>
      <Reveal className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="q0">
          {t.faqs.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-body font-semibold text-lg lg:text-xl text-white hover:no-underline hover:text-sky-300">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-300 text-base leading-relaxed pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};
